/*
  OWNER-assigned MANUAL title chip.
  Visually DISTINCT (parallelogram tag + star icon on the right).
*/
import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "@/lib/api";

let _cache = null;
const _subs = new Set();

async function _fetchOnce() {
  if (_cache) return _cache;
  try {
    const { data } = await api.get("/progression/titles");
    _cache = Array.isArray(data.titles) ? data.titles : [];
  } catch { _cache = []; }
  _subs.forEach(s => s(_cache));
  return _cache;
}
export function refreshTitles() { _cache = null; return _fetchOnce(); }

export function useSpecialTitles() {
  const [titles, setTitles] = useState(_cache || []);
  useEffect(() => {
    let alive = true;
    _fetchOnce().then(v => { if (alive) setTitles(v); });
    const onUpd = (v) => { if (alive) setTitles(v); };
    _subs.add(onUpd);
    return () => { alive = false; _subs.delete(onUpd); };
  }, []);
  return titles;
}

const toAbsUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  return `${process.env.REACT_APP_BACKEND_URL}${u.startsWith("/") ? u : "/" + u}`;
};

/* title can be either a fetched title object OR just a title_id (looked up). */
export function SpecialTitleChip({ title = null, titleId = null, size = "md" }) {
  const titles = useSpecialTitles();
  const t = title || (titleId ? titles.find(x => x.id === titleId) : null);
  if (!t) return null;
  const px = size === "sm" ? 10 : 12;
  return (
    <span data-testid={`title-chip-${t.id}`}
          className="inline-flex items-center gap-1.5 font-cairo font-black"
          style={{
            background: `${t.color || "#f6c96b"}20`,
            color: t.color || "#f6c96b",
            border: `1px solid ${t.color || "#f6c96b"}66`,
            clipPath: "polygon(6% 0, 100% 0, 94% 100%, 0 100%)",
            padding: size === "sm" ? "2px 12px" : "3px 14px",
            fontSize: `${px}px`,
          }}>
      {t.badge_url ? (
        <img src={toAbsUrl(t.badge_url)} alt=""
             className="rounded-full object-cover"
             style={{ width: size === "sm" ? 12 : 14, height: size === "sm" ? 12 : 14 }}/>
      ) : (
        <Star size={size === "sm" ? 10 : 12} />
      )}
      {t.name}
    </span>
  );
}
